import * as React from 'react';
import { Flex, Box, flameTheme } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';
import { IconDesktop } from '@lightspeed/flame/Icon/Desktop';
import { ActionsDropdown } from 'pages/views/devices/DevicesPage/ActionsDropdown';
import { useGetCfd } from 'pages/views/devices/hooks/use-get-cfd';
import { URL } from 'pages/views/devices/utils/help-urls';
import { ACTIONS_DROPDOWN } from 'pages/views/devices/types';
import { STATUS } from 'pages/views/devices/socketClient/types';
import { StatusLabel } from '../../components/StatusLabel';

interface ModalHeaderContentProps {
  showDeviceConnection: boolean;
  handleClick: () => void;
}

const ModalHeaderContent: React.FC<ModalHeaderContentProps> = () => {
  const { fontSizes, colors } = flameTheme;
  const { cfdConnectionStatus, connectionMethodCopy, isCfdConnected } = useGetCfd();

  return (
    <>
      <Box mt={3} mb={2}>
        <IconDesktop size={fontSizes['text-xl']} />
      </Box>
      <Flex flexDirection="row" alignItems="center">
        <Box mr={2}>
          <Text>Customer Facing Display</Text>
        </Box>
        <StatusLabel
          size="medium"
          status={isCfdConnected ? STATUS.CONNECTED : cfdConnectionStatus}
        />
      </Flex>
      <Text fontSize="small" color={colors.textDimmed} fontWeight="normal">
        using {connectionMethodCopy}
      </Text>
      <ActionsDropdown mb={2} type={ACTIONS_DROPDOWN.CFD} learnMore={URL.ABOUT_HUB} />
    </>
  );
};

export { ModalHeaderContent };
